import { Arrows } from '../Arrows/Arrows';

import staticStyles from './arrowButton.module.scss';

interface ArrowButtonProps {
  buttonStyles?: string;
  direction: 'left' | 'right';
  onClick: () => void;
  label?: string;
}

export const ArrowButton = ({
  buttonStyles,
  direction,
  onClick,
  label,
}: ArrowButtonProps) => {
  return (
    <button
      className={`${staticStyles.button} ${buttonStyles}`}
      style={direction === 'left' ? { transform: 'rotate(180deg)' } : {}}
      onClick={onClick}
      type="button"
      aria-label={label ?? 'button'}
    >
      <Arrows styles={staticStyles.arrows} />
    </button>
  );
};
